import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    teamDetails: '',
    businessLoader: false,
    businessDetails: '',
    businessError: '',
    businessProfileLoader: false,
    businessProfileDetails: '',
    businessProfileError: '',
    addressLoader: false,
    addressDetails: [],
    addressError: '',
    businessListLoader: false,
    businessListDetails: [],

    getTeamLoader: true,
    getTeamList: '',
    getTeamData: '',
    subscriptionLoader: false,
    subscriptionDetails: '',
    subscriptionError: '',

    parameterDetails: '',
    parameterError: '',

    subscriptionOrderLoader: false,
    subscriptionOrder: '',
    subscriptionOrderError: '',

    paymentCheckLoader: false,
    paymentCheck: '',
    paymentCheckError: ''
};

export default function homeReducer(state = initState, action) {
    switch (action.type) {
        case actions.TEAM_DETAILS_START: {
            return {
                ...state,
                teamDetails: '',
                getTeamLoader: true,
                getTeamData: []
            };
        }
        case actions.TEAM_DETAILS_SUCCESS: {
            if (action.export) {
                return exportCommonFile(action.export, action.payload?.users, action.data, action.selected, action.extension);
            }
            if ((action.payload?.users?.length === 0 && action.skip === 0) || action.skip === 0) {
                return {
                    ...state,
                    teamDetails: action.payload,
                    getTeamLoader: false,
                    getTeamList: action.payload?.users,
                    getTeamData: action.payload?.users,
                }
            } else if (action.payload?.users.length === 0) {
                return {
                    ...state,
                    getTeamLoader: true
                }
            } else {
                return {
                    ...state,
                    getTeamList: [
                        ...state.getTeamList,
                        ...action.payload?.users
                    ],
                    getTeamData: action.payload?.users,
                    getLoader: false,
                    getDetails: action.payload,
                }
            }
        }
        case actions.TEAM_DETAILS_FAILURE: {
            return {
                ...state,
                getTeamLoader: false
            };
        }
        case actions.BUSINESS_DETAILS_START: {
            return {
                ...state,
                businessLoader: true,
                businessDetails: '',
                businessError: ''
            };
        }
        case actions.BUSINESS_DETAILS_SUCCESS: {
            return {
                ...state,
                businessLoader: false,
                businessDetails: action.payload,
                //businessDetails: { ...action.payload, name: action.payload.businessName },
                businessError: ''
            };
        }
        case actions.BUSINESS_DETAILS_FAILURE: {
            return {
                ...state,
                businessLoader: false,
                businessDetails: '',
                businessError: action.message,
            };
        }
        case actions.UPDATE_BUSINESS_PROFILE_DETAILS_START: {
            return {
                ...state,
                businessProfileLoader: true,
                businessProfileDetails: '',
                businessProfileError: ''
            };
        }
        case actions.UPDATE_BUSINESS_PROFILE_DETAILS_SUCCESS: {
            return {
                ...state,
                businessProfileLoader: false,
                businessProfileDetails: action.payload,
                businessProfileError: ''
            };
        }
        case actions.UPDATE_BUSINESS_PROFILE_DETAILS_FAILURE: {
            return {
                ...state,
                businessProfileLoader: false,
                businessProfileDetails: '',
                businessProfileError: action.message,
            };
        }
        case actions.ADDRESS_DETAILS_START: {
            return {
                ...state,
                addressLoader: true,
            };
        }
        case actions.ADDRESS_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                addressLoader: false,
                addressDetails: action.payload,
            };
        }
        case actions.ADDRESS_DETAILS_FAILURE: {
            return {
                ...state,
                addressLoader: false,
                addressError: action.message,
            };
        }
        case actions.BUSINESS_LIST_START: {
            return {
                ...state,
                businessListLoader: true,
            };
        }
        case actions.BUSINESS_LIST_SUCCESS: {
            return {
                ...state,
                businessListLoader: false,
                businessListDetails: action.payload,
            };
        }
        case actions.BUSINESS_LIST_FAILURE: {
            return {
                ...state,
                businessListLoader: false,
                businessListError: action.message,
            };
        }

        case actions.SUBSCRIPTION_DETAILS_START: {
            return {
                ...state,
                subscriptionLoader: true,
            };
        }
        case actions.SUBSCRIPTION_DETAILS_SUCCESS: {
            return {
                ...state,
                subscriptionLoader: false,
                subscriptionDetails: action.payload
            };
        }
        case actions.SUBSCRIPTION_DETAILS_FAILURE: {
            return {
                ...state,
                subscriptionLoader: false,
                subscriptionError: action.message
            };
        }

        case actions.PARAMETER_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.PARAMETER_DETAILS_SUCCESS: {
            return {
                ...state,
                parameterDetails: action.payload
            };
        }
        case actions.PARAMETER_DETAILS_FAILURE: {
            return {
                ...state,
                parameterError: action.message
            };
        }

        case actions.SUBSCRIPTION_ORDER_START: {
            return {
                ...state,
                subscriptionOrderLoader: true,
            };
        }
        case actions.SUBSCRIPTION_ORDER_SUCCESS: {
            return {
                ...state,
                subscriptionOrderLoader: false,
                subscriptionOrder: action.payload
            };
        }
        case actions.SUBSCRIPTION_ORDER_FAILURE: {
            return {
                ...state,
                subscriptionOrderLoader: false,
                subscriptionOrderError: action.message
            };
        }

        case actions.PAYMENT_CHECK_START: {
            return {
                ...state,
                paymentCheckLoader: true,
            };
        }
        case actions.PAYMENT_CHECK_SUCCESS: {
            return {
                ...state,
                paymentCheckLoader: false,
                paymentCheck: action.payload
            };
        }
        case actions.PAYMENT_CHECK_FAILURE: {
            return {
                ...state,
                paymentCheckLoader: false,
                paymentCheckError: action.message
            };
        }

        case actions.CLEAR_PAYMENT_CHECK_START: {
            return {
                ...state,
            };
        }

        case actions.CLEAR_PAYMENT_CHECK_SUCCESS: {
            return {
                ...state,
                subscriptionOrderLoader: false,
                subscriptionOrder: '',
                subscriptionOrderError: '',
                paymentCheckLoader: false,
                paymentCheck: '',
                paymentCheckError: ''
            };
        }

        case actions.CLEAR_HOME_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_HOME_DETAILS_SUCCESS: {
            return {
                ...state,
                businessDetails: '',
            };
        }

        default:
            return state;
    }
}